/**
 * Utility for checking password expiration
 */

/**
 * Check if password has expired
 * @param passwordUpdatedAt - ISO date string of last password update, or null
 * @returns true if password is expired or never set
 */
export const isPasswordExpired = (passwordUpdatedAt: string | null): boolean => {
	if (!passwordUpdatedAt) {
		return true;
	}

	try {
		const passwordDate = new Date(passwordUpdatedAt);
		const expirationDateThreshold = new Date();

		// Set to 6 months ago for production
		expirationDateThreshold.setMonth(expirationDateThreshold.getMonth() - 6);

		// Set date to 1min ago for testing purposes
		// expirationDateThreshold.setMinutes(expirationDateThreshold.getMinutes() - 1);

		return passwordDate < expirationDateThreshold;
	} catch {
		console.warn('Invalid passwordUpdatedAt date format:', passwordUpdatedAt);
		return true;
	}
};
